import React from 'react';
import { useLanguage } from '../utils/LanguageContext';

const LanguageSwitcher: React.FC = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <div className="language-switcher">
            <button
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => setLanguage('en')}
            >
                🇨🇦CANADA🇨🇦
            </button>
            <button
                className={`lang-btn ${language === 'hu' ? 'active' : ''}`}
                onClick={() => setLanguage('hu')}
            >
                HU
            </button>
        </div>
    );
};

export default LanguageSwitcher;